import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

export interface ContactFormData {
  fullName: string;
  email: string;
  phoneNumber: string;
  serviceType: string;
  budgetRange: string;
  projectDeadline: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private apiUrl = `${environment.apiUrl}/mailer`;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  sendContactForm(contactData: ContactFormData): Observable<any> {
    // Only send HTTP request if running in browser
    if (!isPlatformBrowser(this.platformId)) {
      // During SSR, return a mock success response
      return of({ success: true, message: 'Form will be processed on client side' });
    }

    return this.http.post(`${this.apiUrl}/send`, contactData)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Ha ocurrido un error desconocido';
    
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      if (error.status === 0) {
        errorMessage = 'No se pudo conectar con el servidor. Por favor, verifica tu conexión.';
      } else if (error.status === 400) {
        if (error.error && Array.isArray(error.error)) {
          errorMessage = error.error.map(err => err.errorMessage).join(', ');
        } else if (error.error && typeof error.error === 'object') {
          errorMessage = error.error.error || 'Solicitud incorrecta. Verifica los datos enviados.';
        } else {
          errorMessage = 'Solicitud incorrecta. Verifica los datos enviados.';
        }
      } else {
        errorMessage = `Error al enviar el formulario. Código: ${error.status}`;
      }
    }
    
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}